import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState, TCardId } from '../../../../types/types';
import { getCard } from '../../../../store/model/selectors/getCard';
import { root } from '../../../../store/constants';
import { getBoardIdByCardId } from '../../../../store/model/selectors/getBoardIdByCardId';
import { getBoardUserRecentCards } from '../../../../store/model/board/selectors/getBoardUserRecentCards';
import { boardSetUserRecentCards } from '../../../../rest/effects/board/boardSetUserRecentCards';
import { TStatus } from '../../../../types/model';

export const cardOpen = (
    cardId: TCardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const card = getCard(state, cardId);
        if (!card) return;

        const list = state.model.lists[card.listId];
        if (!list) return;

        const boardId = getBoardIdByCardId(state, cardId);
        if (card.status === TStatus.STATUS_ACTIVE) {
            boardSetUserRecentCards(boardId, [...new Set([cardId, ...getBoardUserRecentCards(boardId)])]);
        }

        root.App.controller.cleverOpenCard(list.dashboardId, cardId);
    };
    return action;
};
